export default {"src":"/uk/_next/static/media/actionsIconGrey.fddd8a3d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};